import { render, staticRenderFns } from "./account-profile-widget.vue?vue&type=template&id=108a40fc&"
import script from "./account-profile-widget.vue?vue&type=script&lang=js&"
export * from "./account-profile-widget.vue?vue&type=script&lang=js&"
import style0 from "./account-profile-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports